import { APIFetcher } from "@fetcher/fetcher";

const envVars = import.meta.env;

const LOL_API = new APIFetcher(
  `${envVars.VITE_API_HOST}${envVars.VITE_API_GROUP_ROUTES}/lol`,
  "",
);

export default LOL_API;
